'use client';

import { useEffect, useState } from 'react';

interface Props {
    children: React.ReactNode;
    cookiebotId?: string
}

export default function ConsentBlockerComponent({ children, cookiebotId }: Props) {
    const [consentGiven, setConsentGiven] = useState(true);

    useEffect(() => {
        if (!cookiebotId) {
            setConsentGiven(true);
            return
        }

        const checkConsent = () => {
            if (window?.Cookiebot === undefined
                || (window?.Cookiebot && window.Cookiebot.hasResponse)) {
                setConsentGiven(true);
            } else {
                setConsentGiven(false);
            }
        };

        const onConsentReady = () => {
            checkConsent();
        };

        if (typeof window !== 'undefined') {
            window.addEventListener('CookiebotOnAccept', onConsentReady);
            window.addEventListener('CookiebotOnDecline', onConsentReady);
            checkConsent();
        }

        const interval = setInterval(() => {
            if (
                typeof window !== 'undefined' &&
                window?.Cookiebot?.hasResponse
            ) {
                setConsentGiven(true);
                clearInterval(interval);
            }
        }, 500);

        return () => {
            clearInterval(interval);
            window.removeEventListener('CookiebotOnAccept', onConsentReady);
            window.removeEventListener('CookiebotOnDecline', onConsentReady);
        };
    }, []);

    return (
        <>
            {!consentGiven && (
                <div
                    style={{
                        position: 'fixed',
                        zIndex: 9999,
                        inset: 0,
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        backdropFilter: 'blur(2px)',
                        cursor: 'not-allowed',
                        pointerEvents: 'all',
                    }}
                >
                    {/* eventualmente messaggio tipo "In attesa del consenso ai cookie..." */}
                </div>
            )}
            {children}
        </>
    );
}